import { categoryMenuView } from './header/categoryMenuView';
import { hamburgerCategoryMenuView } from './header/hamburgerCategoryMenuView';
import { hamburgerToggle } from './header/hamburgerToggle';
import { searchFormView } from './header/searchFormView';

/**
 * header操作時の処理をバンドルするJS
 */
export function headerUiControl() {
  categoryMenuView();
  hamburgerToggle();
  hamburgerCategoryMenuView();
  searchFormView();
}
